import { render, staticRenderFns } from "./AuthorizationLogsTable.vue?vue&type=template&id=8b8bfa72&"
import script from "./AuthorizationLogsTable.vue?vue&type=script&lang=js&"
export * from "./AuthorizationLogsTable.vue?vue&type=script&lang=js&"
import style0 from "./AuthorizationLogsTable.vue?vue&type=style&index=0&id=8b8bfa72&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports